__turbopack_context__.v({
  "addressText": "GetDirectionsSection-module__V-5r5q__addressText",
  "contactSectionContent": "GetDirectionsSection-module__V-5r5q__contactSectionContent",
  "embeddedRoot": "GetDirectionsSection-module__V-5r5q__embeddedRoot",
  "hoursDayTime": "GetDirectionsSection-module__V-5r5q__hoursDayTime",
  "hoursGroup": "GetDirectionsSection-module__V-5r5q__hoursGroup",
  "hoursGroupBlock": "GetDirectionsSection-module__V-5r5q__hoursGroupBlock",
  "hoursLabel": "GetDirectionsSection-module__V-5r5q__hoursLabel",
  "hoursMuted": "GetDirectionsSection-module__V-5r5q__hoursMuted",
  "hoursNote": "GetDirectionsSection-module__V-5r5q__hoursNote",
  "hoursSlotGroup": "GetDirectionsSection-module__V-5r5q__hoursSlotGroup",
  "hoursSlotStack": "GetDirectionsSection-module__V-5r5q__hoursSlotStack",
  "infoBlock": "GetDirectionsSection-module__V-5r5q__infoBlock",
  "infoColumn": "GetDirectionsSection-module__V-5r5q__infoColumn",
  "layoutShell": "GetDirectionsSection-module__V-5r5q__layoutShell",
  "mapCard": "GetDirectionsSection-module__V-5r5q__mapCard",
  "mapColumn": "GetDirectionsSection-module__V-5r5q__mapColumn",
  "mapIframe": "GetDirectionsSection-module__V-5r5q__mapIframe",
});
